<template>
  <component class="support-enum" :is="icon"></component>
</template>
<script>
export default {
  name: 'SupportEnum',
  props: {
    scope: Object,
  },
  computed: {
    diagSupport() {
      return this.$store.state.diagSupport
    },
    icon() {
      var val = this.$getPropValue(this.scope.row, this.scope.column.property)

      for (var item of this.diagSupport) {
        if (item.value == val) {
          return item.icon
        }
      }
      return 'diag-notavailable'
    },
  },
}
</script>
<style lang="less">
.support-enum {
  font-size: 20px;
  line-height: 20px;
  vertical-align: middle;
}
</style>